const findClassByCode = classCode =>
  `/api/v3/students/classes/find_class_by_codes?class_code=${classCode}`

export default findClassByCode
